<div>
    <!-- fault sensor empty component was created to prevent error in console -->
</div>
